<template>
  <section class="landing" id="landing">
    <div class="container">
      <div class="row">
        <div class="col-12 background-large">
          <img src="../../../assets/images/haarlem_landing_large.jpg" alt="Weibliches Model"/>
          <div class="slogan-large fade-in one">
            <span>Haare. Beauty.<br>Wohlgehfühl.</span>
          </div>
          <div class="logo-large fade-in two">
            <img src="../../../assets/images/haarlem_logo_lily.svg" alt="Logo von Haarlem Friseure"/>
          </div>
        </div>
        <div class="col-12 background-small fade-in one">
          <img src="../../../assets/images/haarlem_landing_mobile.jpg" alt="Weibliches Model"/>
          <div class="logo-mobile">
            <img src="../../../assets/images/haarlem_logo_lily.svg" alt="Logo von Haarlem Friseure"/>
          </div>
          <div class="slogan-mobile fade-in two">
            <span>Haare<br>Beauty<br>Wohlgehfühl</span>
          </div>
        </div>
        <div class="col-12 arrow-down fade-in three">
          <div class="fas fa-angle-double-down"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Landing",

}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

.landing {

  .container {
    @include media-breakpoint-up(sm) {
      max-width: 65%;
    }
  }

  .background-large {
    padding: 0;
    border: 10px solid;

    @include media-breakpoint-down(sm) {
      display: none;
    }

    img {
      width: 100%;
    }
  }

  .background-small {
    position: relative;
    top: -10px;
    padding: 0;

    @include media-breakpoint-up(md) {
      display: none;
    }
  }

  .logo-large, .logo-mobile {
    position: absolute;
    transform: translate(-50%, -50%);
  }

  .logo-large {
    top: 36%;
    left: 53%;
    z-index: 1;
  }

  .logo-mobile {
    top: 13%;
    left: 50%;

  }

  .slogan-large, .slogan-mobile {
    position: absolute;
    transform: translate(-50%, -50%);
    text-transform: uppercase;
    font-family: 'Josefin Sans', sans-serif;
    letter-spacing: 4px;
    color: white;
  }

  .slogan-large {
    top: 38%;
    left: 27%;
    z-index: 2;
    letter-spacing: 4px;
    font-size: 3vw;
  }

  .slogan-mobile {
    top: 40%;
    left: 50%;
    text-align: center;
    font-size: 4vh;
  }

  .arrow-down {
    @include media-breakpoint-up(md) {
      display: none;
    }

    .fas {
      position: absolute;
      left: 48%;
      font-size: 30px;

      animation: bounce .5s infinite;
      animation-direction: alternate;

      @keyframes bounce {
        0% {
          margin-top: 0;
        }

        100% {
          margin-top: 10px;
        }
      }
    }
  }

  /* FadeIn Animation */
  /* make keyframes that tell the start state and the end state of our object */
  @-webkit-keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @-moz-keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fade-in {
    opacity: 0; /* make things invisible upon start */
    -webkit-animation: fadeIn ease-in 1; /* call our keyframe named fadeIn, use animation ease-in and repeat it only 1 time */
    -moz-animation: fadeIn ease-in 1;
    animation: fadeIn ease-in 1;
    -webkit-animation-fill-mode: forwards; /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/
    -moz-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    animation-duration: 1s;
  }

  .fade-in.one {
    -webkit-animation-delay: 0.7s;
    -moz-animation-delay: 0.7s;
    animation-delay: 0.7s;
  }

  .fade-in.two {
    -webkit-animation-delay: 1.2s;
    -moz-animation-delay: 1.2s;
    animation-delay: 1.2s;
  }

  .fade-in.three {
    -webkit-animation-delay: 1.6s;
    -moz-animation-delay: 1.6s;
    animation-delay: 1.6s;
  }
}
</style>
